import { useCallback, useEffect, useRef, useState } from "react";

import type { AnnotationViewport } from "../AnnotationViewerBase/helpers";

const INITIAL_VIEWPORT: AnnotationViewport = {
  zoom: 1,
  center: { x: 0.5, y: 0.5 },
};

/**
 * Always remembers the latest stage viewport, but only schedules React renders
 * while the depth panel is visible. The stable callback also avoids resetting
 * AnnotationViewerBase when the panel is toggled.
 */
export function useDepthDebugViewport(showDepthDebug: boolean) {
  const latestViewportRef = useRef<AnnotationViewport>(INITIAL_VIEWPORT);
  const showDepthDebugRef = useRef(showDepthDebug);
  const [visibleViewport, setVisibleViewport] = useState<AnnotationViewport>(INITIAL_VIEWPORT);

  useEffect(() => {
    showDepthDebugRef.current = showDepthDebug;
  }, [showDepthDebug]);

  const onViewportChange = useCallback((nextViewport: AnnotationViewport) => {
    latestViewportRef.current = nextViewport;
    if (showDepthDebugRef.current) {
      setVisibleViewport(nextViewport);
    }
  }, []);

  return {
    viewport: showDepthDebug ? latestViewportRef.current : visibleViewport,
    onViewportChange,
  };
}
